import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a32debe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-info" }
const _hoisted_2 = { class: "wow animate__backInDown" }
const _hoisted_3 = { class: "wow animate__backInLeft" }
const _hoisted_4 = { class: "wow animate__backInRight" }
const _hoisted_5 = { class: "title wow animate__backInDown" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "title wow animate__backInDown" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "title wow animate__backInDown" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { class: "title wow animate__backInDown" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import { nextTick, onMounted, ref } from 'vue'
import { drawChina } from './echartMap'
import WOW from 'wow.js'
import * as echarts from "echarts"
import talentView from '@/components/talentView/talentView.vue'
import welfareView from '@/components/talentView/welfareView.vue'
import leagueView from '@/components/talentView/leagueView.vue'
import envView from '@/components/talentView/envView.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


const ChinaMap = ref(null)
onMounted(() => {
    new WOW().init()
    // nextTick(() => {
    //     drawChina(ChinaMap)
    // })
    // const myChart = echarts.init(ChinaMap.value)
    // window.addEventListener('resize', () => {
    //     myChart.resize()
    // })
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('RekeyMed')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('Customer Needs')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('High quality service')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('talenttitle1')), 1),
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('talenttitle2')), 1),
      _hoisted_6
    ]),
    _createVNode(talentView),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('welfaretitle1')), 1),
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('welfaretitle2')), 1),
      _hoisted_8
    ]),
    _createVNode(welfareView),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('leaguetitle2')), 1),
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('leaguetitle1')), 1),
      _hoisted_10
    ]),
    _createVNode(leagueView),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('envtitle2')), 1),
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('envtitle1')), 1),
      _hoisted_12
    ]),
    _createVNode(envView)
  ], 64))
}
}

})